export class Onix {
  _id: string;
  list: string;
  value: string;
  label: string;
  etichetta: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Onix.ts